import React from 'react';
import { Provider } from 'react-redux';
import UpcomingEventPage from '../../page/UpcomingEventPage';
import store from '../../configureStore';
import * as settingsActions from '../../actions/settings';
import SmallWidgetContainer from '../SmallWidgetContainer';

export default class UpcomingEventWidgetContainer extends SmallWidgetContainer {
  render() {
    return (
      <div>
        <Provider store={store}>
          <UpcomingEventPage {...this.props} />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingsActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingsActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingsActions.setSetting({ key, value }));
